<template>
  <div
    class="catalogSubsetBanner"
    :class="['catalogSubsetBanner', { 'catalogSubsetBanner--border': isBorder }]"
  >
    <div class="catalogSubsetBanner__header">
      <img
        class="catalogSubsetBanner__image"
        :src="require(`~/assets/img/catalog_subset_banner.svg`)"
        alt=""
      />
      <div class="catalogSubsetBanner__headerText">Twoje konto posiada Minikatalog</div>
    </div>
    <div class="catalogSubsetBanner__content">
      Twoje konto posiada Minikatalog, czyli zbiór produktów dostosowany specjalnie do Twojej firmy.
      Ułatwia szybki dostęp do najczęściej zamawianych artykułów, co przyspiesza zakupy.
    </div>
    <div class="catalogSubsetBanner__button">
      <v-button
        :to="
          localePath({
            name: 'dashboard-catalog-subset',
          })
        "
        text="Przejdź do minikatalogu"
        theme="purple"
        full-width
      />
    </div>
  </div>
</template>

<script>
import VButton from '@/components/VButton.vue';
import IconLink from '@/components/IconLink.vue';

export default {
  name: 'CatalogSubsetBanner',
  components: { IconLink, VButton },
  props: {
    isBorder: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.catalogSubsetBanner {
  display: flex;
  align-items: center;
  padding: 1rem 5rem 1rem 1rem;
  background-color: $cWhite;

  @include rwd('laptop') {
    padding: 1rem 2rem 1rem 1rem;
  }

  @include rwd('tablet') {
    flex-wrap: wrap;
    padding: 1rem 2rem 2.5rem 1rem;
  }

  &__image {
    display: flex;
  }

  &__content {
    font-size: 1.6rem;
    line-height: 1.5;
    color: $cMainNeutral;
    padding-left: 4rem;
    font-weight: 600;
    max-width: 78rem;
    padding-right: 3rem;

    @include rwd('tablet') {
      padding: 1.2rem 1rem;
      font-weight: 600;
      font-size: 1.4rem;
    }
  }

  &__button {
    margin-left: auto;

    @include rwd('tablet') {
      margin-left: 0;
      padding: 0 1rem;
      flex: 0 0 100%;
      max-width: 100%;
    }
  }

  &__header {
    @include rwd('tablet') {
      display: flex;
      align-items: center;
      flex: 0 0 100%;
      max-width: 100%;
      border-bottom: 1px solid $cAddLight;
    }
  }

  &__headerText {
    font-size: 1.6rem;
    line-height: 1.25;
    display: none;
    font-weight: 700;

    @include rwd('tablet') {
      display: block;
    }
  }

  &--border {
    border: 1px solid $cAddLight;
    border-radius: 5px;
    padding: 0 2rem 0 0;
    overflow: hidden;

    @include rwd('tablet') {
      padding: 0 0 1rem 0;
    }
  }
}
</style>
